import type { FC } from 'react';
import { memo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Tooltip } from '../../../components/GraphModal/Tooltip';
import { IconTextStyling } from '../../../components/icons/Icons';
import { useHasFormatting } from '../../../editor/editorjs/editorjs-hooks';

const messages = defineMessages({
  formatHintTooltip: {
    defaultMessage: 'Highlight text in your message to display formatting options.',
    id: 'tZDjmZ',
  },
});

interface FormatTextHintButtonProps {}

export const FormatTextHintButton: FC<FormatTextHintButtonProps> = memo(
  function FormatTextHintButton(props) {
    const {} = props;

    const hasFormatting = useHasFormatting();
    if (!hasFormatting) return null;

    return (
      <Tooltip content={<FormattedMessage {...messages.formatHintTooltip} />}>
        {/* A span wrapping the SVG is required to make the tooltip work. */}
        <span className="p-2 text-gray-medium hover:text-gray-dark">
          <IconTextStyling className="w-7 h-7 sm:w-5 sm:h-5" />
        </span>
      </Tooltip>
    );
  },
);
